__turbopack_context__.v({
  "Button": "index-module__25Xava__Button",
});
